/**
 * RisksList — строки «По рискам» (триал истёк / ожидает карту / просрочена / заблокирована)
 * с числом и переходом в «Клиенты» с фильтром статуса. Общий для карточки
 * дашборда на десктопе и мобилке.
 */

import {ChevronRight} from 'lucide-react';

import type {SubscriptionStatus} from '@services/clients';
import type {DashboardSummary} from '@services/dashboard';

const ROWS: {
  status: SubscriptionStatus;
  label: string;
  dot: string;
  key: keyof DashboardSummary['risks'];
}[] = [
  {status: 'trial_expired', label: 'Триал истёк', dot: '#B4501B', key: 'trialExpired'},
  {status: 'awaiting_card', label: 'Ожидает карту', dot: '#B07908', key: 'awaitingCard'},
  {status: 'past_due', label: 'Просрочена', dot: '#C6362C', key: 'pastDue'},
  {status: 'blocked', label: 'Заблокирована', dot: '#55524C', key: 'blocked'},
];

type RisksListProps = {
  risks: DashboardSummary['risks'];
  onPick: (status: SubscriptionStatus) => void;
};

export const RisksList = ({risks, onPick}: RisksListProps) => (
  <div className="mt-2.5 flex flex-col">
    {ROWS.map((r, i) => (
      <button
        key={r.status}
        onClick={() => onPick(r.status)}
        className={`flex items-center justify-between py-2 text-left ${
          i < ROWS.length - 1 ? 'border-b border-skr-hairline' : ''
        }`}
      >
        <span className="flex items-center gap-[9px] text-[13px] text-skr-ink">
          <span className="size-2 rounded-[2px]" style={{background: r.dot}} />
          {r.label}
        </span>
        <span className="flex items-center gap-1.5">
          <span className="font-mono text-[15px] font-semibold">{risks[r.key]}</span>
          <ChevronRight className="size-3.5 text-skr-chevron" strokeWidth={2} />
        </span>
      </button>
    ))}
  </div>
);
